module.exports = __webpack_public_path__ + "static/media/Tornadus_gaussian2.c0ee2605.png";